/**
 * useResultsView — props-bundling hook for Step 5+ Results view.
 *
 * This hook does NOT create new state or effects. It simply collects
 * existing App.jsx closures into named prop bundles so components
 * receive focused, stable prop objects instead of 70+ individual props.
 */
export default function useResultsView({
  // Alert deps
  formStep, calculoReady, rows, invalidBaseRows, updaterWarnings,
  calidadIndicesBloqueante, mixedTagInconsistencyCount, rangoIndicesError,
  weakIndexStats, laborIntegrity, modoHerramienta, faltaHaberActual,
  rowsVista, indicesUnavailable,

  // Tab state
  activeInfoTab, setActiveInfoTab, goToStep,

  // Basica tab deps
  empleadores, retroactivoEstimado, contextoDictamen,
  indicesLoading, tasaInteresTipo, setTasaInteresTipo,
  TASAS_DISPONIBLES, setExpediente, expediente,
  escenariosLitigio, impactoTasa, serieStatus, activeRules,
  preEmisionAudit, canGenerarDictamen, dictamenLoading,
  noPerjuicioEconomico, allowLitigioArtesanalBypass,
  contrasteNoPerjuicio, umbralConfiscatoriedadPct,
  noPerjuicioSimulationError, motivoBloqueoDictamen,
  onGenerarDictamen, formatArs, setMostrarViabilidad,
  registrarBypassLitigioArtesanal, rowsNormativa,

  // Completa tab deps
  showAllDetalle, setShowAllDetalle,
  dataTablePage, setDataTablePage, setRowsEditadas,
  ultimoPeriodoDetectado,

  // Sidebar deps
  modoCaso, edadDetectada, aniosTareasCuidado,
  aniosAportesTotales, estadoJubilatorio,
  normativeVersion, normativeAudit, faltanMesesAporte,
  mostrarViabilidad,
}) {
  return {
    resultsAlertsProps: {
      formStep, calculoReady, rows, invalidBaseRows, updaterWarnings,
      calidadIndicesBloqueante, mixedTagInconsistencyCount, rangoIndicesError,
      weakIndexStats, laborIntegrity, modoHerramienta, faltaHaberActual,
      rowsVista, indicesUnavailable,
    },
    basicaTabProps: {
      formStep, calculoReady, rows, rowsVista, empleadores, retroactivoEstimado,
      contextoDictamen, indicesLoading, tasaInteresTipo, setTasaInteresTipo,
      TASAS_DISPONIBLES, activeRules, modoHerramienta, setExpediente, expediente,
      escenariosLitigio, impactoTasa, serieStatus, preEmisionAudit,
      canGenerarDictamen, dictamenLoading, noPerjuicioEconomico,
      allowLitigioArtesanalBypass, contrasteNoPerjuicio, umbralConfiscatoriedadPct,
      noPerjuicioSimulationError, motivoBloqueoDictamen, onGenerarDictamen,
      formatArs, setMostrarViabilidad, registrarBypassLitigioArtesanal,
      goToStep, rowsNormativa,
    },
    completaTabProps: {
      formStep, calculoReady, rows, rowsVista, goToStep, ultimoPeriodoDetectado,
      showAllDetalle, setShowAllDetalle, modoHerramienta, indicesLoading,
      dataTablePage, setDataTablePage, setRowsEditadas, activeRules,
      expediente, contextoDictamen,
    },
    sidebarProps: {
      modoCaso, edadDetectada, aniosTareasCuidado, aniosAportesTotales,
      estadoJubilatorio, normativeVersion, normativeAudit, faltanMesesAporte,
      mostrarViabilidad, setMostrarViabilidad, formStep,
    },
  }
}
